module.exports = __webpack_public_path__ + "static/media/ACA.ed35f6b8.png";